/* import __COLOCATED_TEMPLATE__ from './mcp-actions-collapsible-list.hbs'; */
/* RESPONSIBLE TEAM: team-actions */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { getMcpTemplateByName } from 'embercom/models/workflow-connector/constants/mcp-templates';

interface Args {
  actions: any[];
  isOpen: boolean;
  mcpServerId: string | number | null;
  mcpServerName: string | null;
  onAddActionClick: () => void;
  onDeleteMcpServerClick: (mcpServerId: string | number) => void;
  onHeadingClicked: () => void;
  selectedColumns: any[];
  target: string;
  title: string | null;
  totalCount: number;
  showEditOrDeleteMcpServerModal: () => void;
}

export default class McpActionsCollapsibleList extends Component<Args> {
  @service declare intl: IntlService;

  get arrowIconClass() {
    return this.args.isOpen ? 'small-up-arrow' : 'small-down-arrow';
  }

  get mcpServerIcon(): string {
    if (this.args.mcpServerId === 'default_connectors') {
      return 'mcp/default';
    }

    if (this.args.mcpServerName) {
      let template = getMcpTemplateByName(this.args.mcpServerName);
      if (template) {
        return `${template.icon}-list`;
      }
    }

    return 'mcp/custom-list';
  }

  get mcpServerDescription(): string | null {
    let descriptionKey = this.getMcpServerDescriptionKey();
    return descriptionKey ? this.intl.t(descriptionKey) : null;
  }

  private getMcpServerDescriptionKey(): string | null {
    if (this.args.mcpServerId === 'default_connectors') {
      return 'workflow-connector.actions.data-connectors-description';
    }

    if (this.args.mcpServerName) {
      let template = getMcpTemplateByName(this.args.mcpServerName);
      if (template) {
        return template.descriptionKey;
      }
    }

    return null;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::McpActionsCollapsibleList': typeof McpActionsCollapsibleList;
    'workflow-connector/mcp-actions-collapsible-list': typeof McpActionsCollapsibleList;
  }
}
